export const blueCircle = (
  <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="5" fill="#0F3FFB" />
  </svg>
);

export const dottedCircle = (
  <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="5"
      cy="5"
      r="4"
      stroke="#0F3FFB"
      strokeWidth={1.5}
      fill="transparent"
      shapeRendering="geometricPrecision"
    />
  </svg>
);
